import { createContext, useContext } from "react";

interface MessageBarContextType {
  isVisible: boolean;
  setIsVisible: (visible: boolean) => void;
}

const MessageBarContext = createContext<MessageBarContextType | undefined>(undefined);

export const useMessageBar = () => {
  const context = useContext(MessageBarContext);
  if (!context) {
    throw new Error("useMessageBar must be used within a MessageBarProvider");
  }
  return context;
};

export default MessageBarContext;
